
export const ClassicGradient = {
    max: 0xf6fbed,
    midMax: 0xf3c70c,
    mid: 0xfc4809,
    baseMid: 0x440284,
    base: 0x121212
}

const HotMetalGradient = [
    0xf4fde0,
    0xf4e223,
    0xf3a109,
    0xee7008,
    0xe13b0d,
    0xb00479,
    0x4f0186,
    0x200175,
    0x000000
]

const DefaultGradient = [
    0x1085f8,
    0x34973d,
    0x34973d,
    0xb456c7,
    0x9b7d14,
    0x149c9e
]


const managuaGradient = [
    0xd28744,
    0xa85836,
    0x7d342d,
    0x531d2e,
    0x3c224c,
    0x3d407f,
    0x4a6bad,
    0x5c9fd5,
    0x71e0fe,
]

export const ColorsArray = HotMetalGradient;

